import { render } from "./PageTwoColumns.vue?vue&type=template&id=ced4fbc8&ts=true"
import script from "./PageTwoColumns.vue?vue&type=script&lang=ts"
export * from "./PageTwoColumns.vue?vue&type=script&lang=ts"

import "./PageTwoColumns.vue?vue&type=style&index=0&id=ced4fbc8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__